module.exports = __webpack_public_path__ + "static/media/logo-white.cee5f653.svg";